var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"udef-icon",class:{small: _vm.small, medium: _vm.medium, big: _vm.big},style:(_vm.getIconStyles),on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }